import React from 'react';
import PropTypes from 'prop-types';
import { Card, Box, Typography, Grid } from '@mui/material';
import AdminButton from 'components/common/AdminButton';
import {
  PersonAddOutlined,
  BadgeOutlined,
} from '@mui/icons-material';

/**
 * Quick actions component providing primary navigation buttons
 * @param {Object} props - Component props
 * @param {Function} props.onAddEmployee - Handler for add employee action
 * @param {Function} props.onCreateRole - Handler for create role action
 * @param {boolean} props.disabled - Disables all action buttons when true
 * @returns {React.Component} Quick actions card with navigation buttons
 */
function QuickActions({ 
  onAddEmployee, 
  onCreateRole, 
  disabled = false 
}) {
  const actions = [
    {
      label: 'Add Employee',
      icon: <PersonAddOutlined />,
      onClick: onAddEmployee,
      variant: 'contained',
      color: 'primary',
    },
    {
      label: 'Create Role Definition',
      icon: <BadgeOutlined />,
      onClick: onCreateRole,
      variant: 'outlined',
      color: 'primary',
    },
  ];

  return (
    <Card>
      <Box p={3}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Quick Actions
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Common tasks for managing people and roles
        </Typography>
        <Grid container spacing={2} mt={1}>
          {actions.map((action, index) => (
            <Grid item key={index}>
              <AdminButton
                variant={action.variant}
                color={action.color}
                startIcon={action.icon}
                onClick={action.onClick}
                disabled={disabled}
              >
                {action.label}
              </AdminButton>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Card>
  );
}

QuickActions.propTypes = {
  onAddEmployee: PropTypes.func.isRequired,
  onCreateRole: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default QuickActions;